import {
    FETCH_ALL_PERSONS,
    FETCH_MORE_PERSONS,
    QUERY_CHANGE,
    FILTER_CHANGE,
    PAGINATION_CHANGE,
    FILTER_SET,
    FILTER_UPDATE,
    MULTIPLE_FILTERS_UPDATE,
    FILTER_CLEAR,
    FILTER_CLEAR_GROUP,
    FILTER_CLEAR_ALL
} from '../constants/ActionTypes';
import Utils from '../views/reactViews/Utils';
import _ from 'underscore';

export const getInitialState = () => {
    var search = Utils.manageSearchObject({sort: 'join', filter: '', count: 48, offset: 0, total: 0});
    return {
        search: search,
        attributeSelected: [],
        instances: {}
    };
};

function QueryReducer(state = getInitialState(), action = null) {
    switch (action.type) {
    case FETCH_ALL_PERSONS: {
        const newQuery = Object.assign({}, state.search, {total: action.response.total});
        return Object.assign({}, state, {
            search: newQuery
        });
    }

    case FETCH_MORE_PERSONS:{
        const newQuery = Utils.manageSearchObject(state.search, {
            total: action.response.total,
            offset: action.response.offset
        });
        return Object.assign({}, state, {
            search: newQuery
        });
    }

    case QUERY_CHANGE: {
        const newQuery = Utils.manageSearchObject(state.search, action.query);
        return Object.assign({}, state, {
            search: newQuery
        });
    }

    case PAGINATION_CHANGE: {
        let total = action.query.total;
        if (!total) {
            total = state.search.total;
        }
        const count = state.search.count;
        let currentPage = action.query.currentPage === undefined ? state.search.currentPage : action.query.currentPage;

        let newOffset = currentPage * count;
        if (newOffset >= total) {
            newOffset = Math.floor((total - 1) / count) * count;
            currentPage = Math.ceil(newOffset / count);
        }
        if (currentPage <= 0) {
            newOffset = 0;
            currentPage = 0;
        }
        const newQuery = Utils.manageSearchObject(state.search, {currentPage: currentPage, offset: newOffset, total: total});

        return Object.assign({}, state, {
            search: newQuery
        });
    }

    case FILTER_CHANGE: {
        let attributeSelected = state.attributeSelected || [];
        let groupSelected = action.query.groupSelected;
        if (_.findWhere(attributeSelected, {keyName: groupSelected.keyName})) {
            attributeSelected = _.reject(attributeSelected, {keyName: groupSelected.keyName});
        } else {
            attributeSelected.push(groupSelected);
        }
        return Object.assign({}, state, {
            attributeSelected: attributeSelected
        });
    }

    case FILTER_SET: {
        const {instanceId, key, value} = action.data;
        const instances = {...state.instances};
        const instance = instances[instanceId] || [];

        const existingIndex = instance.findIndex(filter => filter.key === key && filter.value === value);
        if (existingIndex === -1) {
            instance.push({key, value});
        } else {
            instance.splice(existingIndex, 1);
        }

        instances[instanceId] = instance;

        return {
            ...state,
            instances
        };
    }

    case FILTER_UPDATE: {
        const {instanceId, key, value} = action.data;
        const instances = {...state.instances};
        const instance = instances[instanceId] || [];
        const filter = instance.find(filter => filter.key === key);
        if (!filter) {
            instance.push({key, value});
        } else {
            filter.value = value;
        }
        instances[instanceId] = instance;
        return {
            ...state,
            instances
        };
    }

    case MULTIPLE_FILTERS_UPDATE: {
        const instances = {...state.instances};
        action.data.filters.map(filter => {
            const {instanceId, key, value} = filter;
            const instance = instances[instanceId] || [];
            const filterExist = instance.find(filter => filter.key === key && filter.value === value);
            if (!filterExist) {
                instance.push({key, value});
            } else {
                filterExist.value = value;
            }
            instances[instanceId] = instance;

        });
        return {
            ...state,
            instances
        };
    }

    case FILTER_CLEAR_GROUP: {
        const instances = {...state.instances};
        if ( instances.hasOwnProperty(action.data.instanceId)) {
            instances[action.data.instanceId] = _.reject(instances[action.data.instanceId],
                g => g.key === action.data.key);
        }
        return {
            ...state,
            instances
        };
    }

    case FILTER_CLEAR: {
        const instances = {...state.instances};
        instances[action.data.instanceId] = [];
        return {
            ...state,
            instances
        };
    }

    case FILTER_CLEAR_ALL:
    {
        return getInitialState();
    }

    default:
        return state;
    }
}

export default QueryReducer;
